import type React from "react";
import { Link } from "react-router-dom";
import type { Goal } from "@/types/goal";
import { useProgress } from "@/hooks/useProgress";
import { useMemo } from "react";
import { formatDate } from "@/utils/date";

interface GoalItemProps {
	goal: Goal;
}

const GoalItem: React.FC<GoalItemProps> = ({ goal }) => {
	const { progress } = useProgress(goal.id);

	// 最新の進捗率を計算
	const latestProgress: number = useMemo(() => {
		if (!progress.length) return 0;
		return progress.sort(
			(a, b) =>
				new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
		)[0].progress;
	}, [progress]);

	// カテゴリーの日本語表示
	const categoryLabel = {
		short: "短期",
		medium: "中期",
		long: "長期",
	}[goal.category];

	return (
		<div className="bg-white p-4 rounded shadow">
			<h3 className="text-xl font-semibold mb-2">{goal.title}</h3>
			<p className="text-sm text-gray-500 mb-2">カテゴリー: {categoryLabel}</p>
			<div className="flex justify-between items-center mb-2">
				<span>進捗: {latestProgress}%</span>
				<span>期限: {formatDate(goal.endDate)}</span>
			</div>
			<div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
				<div
					className="bg-blue-600 h-2.5 rounded-full"
					style={{ width: `${latestProgress}%` }}
				/>
			</div>
			<div className="mt-2 flex justify-between items-center">
				<Link
					to={`/webapp/goals/${goal.id}`}
					className="text-blue-500 hover:underline"
				>
					詳細を見る
				</Link>
				<span className="text-sm text-gray-500">
					{goal.status === "completed"
						? "完了"
						: goal.status === "in_progress"
							? "進行中"
							: "未着手"}
				</span>
			</div>
		</div>
	);
};

export default GoalItem;
